import { AssociatedLendersDispatch, eAssociatedLendersActionType } from './AssociatedLendersAction';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from '../../types/rest/IFetchStatus';
import {
  getAssociatedLendersAsync,
  getAssociatedLendersForClientAsync,
  updateAssociatedLendersAsync,
} from './AssociatedLendersAPI';

export const doGetAsyncAssociatedLenders = async (clientId: string, dispatch: AssociatedLendersDispatch) => {
  dispatch({ type: eAssociatedLendersActionType.SetAssociatedLendersFetchStatus, payload: createFetchInProgress() });
  dispatch({ type: eAssociatedLendersActionType.SetAssociatedLendersError, payload: null });
  try {
    const data = await getAssociatedLendersAsync(clientId);
    dispatch({ type: eAssociatedLendersActionType.SetAssociatedLenders, payload: { lenders: data, clientId } });
    dispatch({ type: eAssociatedLendersActionType.SetAssociatedLendersFetchStatus, payload: createFetchedSuccess() });
  } catch (e: any) {
    dispatch({ type: eAssociatedLendersActionType.SetAssociatedLendersError, payload: e.message });
    dispatch({ type: eAssociatedLendersActionType.SetAssociatedLendersFetchStatus, payload: createFetchedWithError() });
  }
};

export const doGetAsyncAssociatedLendersForClient = async (dispatch: AssociatedLendersDispatch) => {
  dispatch({ type: eAssociatedLendersActionType.SetAssociatedLendersFetchStatus, payload: createFetchInProgress() });
  dispatch({ type: eAssociatedLendersActionType.SetAssociatedLendersError, payload: null });
  try {
    const data = await getAssociatedLendersForClientAsync();
    dispatch({
      type: eAssociatedLendersActionType.SetAssociatedLenders,
      payload: { lenders: data, clientId: 'client' },
    });
    dispatch({ type: eAssociatedLendersActionType.SetAssociatedLendersFetchStatus, payload: createFetchedSuccess() });
  } catch (e: any) {
    dispatch({ type: eAssociatedLendersActionType.SetAssociatedLendersError, payload: e.message });
    dispatch({ type: eAssociatedLendersActionType.SetAssociatedLendersFetchStatus, payload: createFetchedWithError() });
  }
};

export const doUpdateAsyncAssociatedLenders = async (
  clientId: string,
  addLenders: string[],
  removeLenders: string[],
  dispatch: AssociatedLendersDispatch
) => {
  dispatch({
    type: eAssociatedLendersActionType.SetUpdateAssociatedLendersFetchStatus,
    payload: createFetchInProgress(),
  });
  dispatch({ type: eAssociatedLendersActionType.SetUpdateAssociatedLendersError, payload: null });
  try {
    const newLenders = await updateAssociatedLendersAsync(clientId, addLenders, removeLenders);
    dispatch({ type: eAssociatedLendersActionType.SetAssociatedLenders, payload: { lenders: newLenders, clientId } });
    dispatch({
      type: eAssociatedLendersActionType.SetUpdateAssociatedLendersFetchStatus,
      payload: createFetchedSuccess(),
    });
  } catch (e: any) {
    dispatch({ type: eAssociatedLendersActionType.SetUpdateAssociatedLendersError, payload: e.message });
    dispatch({
      type: eAssociatedLendersActionType.SetUpdateAssociatedLendersFetchStatus,
      payload: createFetchedWithError(),
    });
  }
};
